export enum ResultFormat {
  RawJson = 'Raw JSON',
  PrettyJson = 'Pretty JSON',
  Table = 'Table',
  Graph = 'Graph',
}
